export default "__VITE_ASSET__2b665b48__"